import { useEffect } from "react";
import { NavigationType, useLocation, useNavigationType } from "react-router-dom";

const NavCountKey = "navCount";

export function getNavCount(): number {
  const count = sessionStorage.getItem(NavCountKey);
  return parseInt(count || "0");
}

/**
 * Hook that stores the navigation count of a session on the 'navCount' key
 */
export function useNavigationCount() {
  const location = useLocation();

  const type = useNavigationType();

  useEffect(() => {
    const storedCount = parseInt(sessionStorage.getItem(NavCountKey) || "0", 10);

    if (type === NavigationType.Pop) {
      sessionStorage.setItem(NavCountKey, (storedCount - 1).toString(10));
    } else {
      sessionStorage.setItem(NavCountKey, (storedCount + 1).toString(10));
    }
  }, [location]);
}
